// extracted by mini-css-extract-plugin
export var root = "IJcA";
export var rootContainer = "E6eU";
export var rootHamburger = "_2H5W";
export var rootLogo = "r2Du";
export var rootMobileOpen = "xY0j";
export var rootScrolled = "RtA6";
export var rootSearching = "kdIj";